import axios from "axios";
import { useEffect } from "react";
import { isDesktop } from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { menu, sessionId, store_locations, topHeaderData } from "../Reducer/homeReducer";
import { faqMetaData, homeLoader, metaDetails } from "../Reducer/metaReducer";
import { persistor } from "../Store/store";
import { base_url, postHeader } from "./request";
import ReactPixel from 'react-facebook-pixel';

export default function MainRequest() {
    const session = useSelector(state => state.persistedReducer.home.session_id);
    const isLogin = useSelector(state => state.persistedReducer.home.isLogin);
    const routePath = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        // loadGoogleAnalytics()
        // loadGoogleTagManager('GTM-PMMF8ZP');
        // AffirmPayment()
        if(!routePath?.pathname.includes("/special")){
           GotoTop();
        }
        if (!routePath?.pathname?.includes("product-detail")) {
            MetaTag();
            faqMeta()
        }
        ReactPixel.init('1439897286322610');
        ReactPixel.pageView();
    }, [routePath?.pathname]);


    useEffect( () => {
         clearlocal();
        SessionId();
        megamenu();
        locationApi();
        // AffirmPayment()
    }, [])
    //--------------------- clear localstorage------------------
    // const clearlocal = async () => {
    //     var localdate = localStorage.getItem('bw-localdate');
    //     var date = new Date().getDate();
    //     if (localdate != date) {
    //         await persistor.flush();
    //         localStorage.clear();
    //         sessionStorage.clear();
    //         localStorage.setItem("bw-localdate", date);
    //         window.location.reload()
    //     }
    // }
    
    const clearlocal = async () => {
        const now = new Date();
        const midnight = new Date(now);
        midnight.setHours(24, 0, 0, 0);
        const timeUntilMidnight = midnight - now;
        setTimeout(() => {
          persistor.flush();
          localStorage.clear();
          sessionStorage.clear();
          window.location.reload();
        }, timeUntilMidnight);
      };
    
    //-------------------- go to top ---------------------
    const GotoTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }

 //------------------- google TagManager start ----------------------
 function loadGoogleTagManager(containerId, dataLayerName = 'dataLayer') {
    window[dataLayerName] = window[dataLayerName] || [];
    window[dataLayerName].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });
  
    const scriptTag = document.createElement('script');
    scriptTag.async = true;
    scriptTag.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}&l=${dataLayerName !== 'dataLayer' ? dataLayerName : ''}`;
  
    const firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(scriptTag, firstScript);
  }

//------------------- google analytics start----------------------
function loadGoogleAnalytics(trackingId) {
    // Load the Google Analytics script asynchronously
    const scriptTag = document.createElement('script');
    scriptTag.async = true;
    scriptTag.src = `https://www.googletagmanager.com/gtag/js?id=G-2NP6Y9VXKW`;
    document.head.appendChild(scriptTag);
  
    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
  
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', trackingId);
  }
  
   
  const MetaTag = () => {
    dispatch(homeLoader(true));
    dispatch(metaDetails([]));
    axios
      .get(
        `${base_url}/common/metatag?url=${window.location.pathname.slice(1)}`
      )
      .then((res) => {
        if (res.data.status == 1) {
          dispatch(metaDetails(res.data.data));
          // console.log("res.data.data",res.data.data)
          dispatch(homeLoader(false));
        }
      })
      .catch((error) => console.log(error));
  };

    const faqMeta = async () => {
        try {
          await axios.get(`${base_url}/common/faq?url=${window.location.pathname.slice(1)}`).then((res) => {
                if (res.data.status==1 || res.data.status==0) {
                    dispatch(faqMetaData(res.data))
                }
            })
        } catch (error) {
            console.log(error)
        }
    }

    //------------------- Session Id -----------------
    const SessionId = () => {

        if (session?.length || isLogin) {
            console.log("session exist!")
        } else {
            axios.get(base_url + '/home/getsessionid')
                .then(res => {
                    if (res.data.status == 1) {
                        dispatch(sessionId(res.data.data?.session_id))
                    } else {
                        console.log("sessionid not generated")
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        }
    }

    //------------------------ mega menu ---------------------
    const megamenu = () => {
        const device_type = window.innerWidth > 991 ? 1 : 2;
        axios.get(base_url + '/home/megamenu?device_type=' + device_type, {
            headers: postHeader
        })
            .then(response => {
                if (response.data.status == 1) {
                    dispatch(menu(response.data.data))
                    dispatch(topHeaderData(response?.data?.top_header))
                } else {
                    toast.error(response.message, { autoClose: 3000 });
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }
    //------------------------ Location API---------------------
    const locationApi = () => {
        axios.get(base_url + '/common/store_locations')
            .then(res => {
                if (res.data.status == 1) {
                    dispatch(store_locations(res.data.data))
                    // console.log(res.data.data)
                } else {
                    console.log("store locations not found")
                }
            })
            .catch(err => {
                console.log(err)
            })
    }

    //-------------------- LOG OUT--------------

    return null;
}
